import React from 'react';

import {QueueItem} from './components';
import {addPerson} from './icons';
import {useQueueContext} from '../../../../context/QueueProvider';
import styles from './Queue.module.scss';
import Skeleton from 'react-loading-skeleton';

export default function Queue() {
  const {
    songs,
    upNextSongs,
    remove,
    removeFromUpNext,
    loading,
  } = useQueueContext();

  const queueItems = songs.map((song) => (
    <QueueItem key={song.id} song={song} onRemove={remove} />
  ));

  const upNextItems = upNextSongs.map((song) => (
    <QueueItem key={song.id} song={song} onRemove={removeFromUpNext} />
  ));

  return (
    <div className={styles.Queue}>
      <div className={styles.Header}>
        <div className={styles.HeaderWrapper}>
          <div className={styles.HeaderText}>Queue</div>
          <div className={styles.HeaderTextSubdued}>{songs.length}</div>
        </div>
        <div className={styles.ButtonWrapper}>
          <button
            className={styles.HeaderButton}
            type="button"
            onClick={() => {}}
          />
          {addPerson}
        </div>
      </div>
      <div className={styles.QueueListWrapper}>
        <ol className={styles.QueueList}>{queueItems}</ol>
        {loading && (
          <Skeleton
            height={42}
            style={{marginTop: '8px', marginBottom: '8px'}}
          />
        )}
        {upNextItems.length > 0 && (
          <div className={styles.UpNextWrapper}>
            <div className={styles.HeaderText}>Up Next</div>
            <div className={styles.HeaderTextSubdued}>{upNextItems.length}</div>
          </div>
        )}
        <ol className={styles.QueueList}>{upNextItems}</ol>
      </div>
    </div>
  );
}
